module.exports = __webpack_public_path__ + "img/1.acd493b4.jpg";